import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  href
}: CTAButtonProps) {
  const baseClasses = 'bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white font-black py-5 px-8 rounded-xl shadow-2xl transform transition-all hover:scale-105 text-xl md:text-2xl text-center w-full md:w-auto inline-block cursor-pointer border-b-4 border-red-800 active:border-b-0 active:translate-y-1 uppercase tracking-wide';
  if (href) {
    return <a href={href} className={`${baseClasses} ${className}`} data-id="element-14">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={`${baseClasses} ${className}`} data-id="element-15">
      {children}
    </button>;
}